import { useContext } from 'react';
import {
    Table, TableBody, TableCell, Tooltip, Zoom,
    TableHead, TablePagination, TableRow, IconButton, TableFooter, Typography, TableContainer,
    CircularProgress,
    LinearProgress
} from '@mui/material';
import { SearchOutlined as DetailsIcon } from '@mui/icons-material';
import { ordersContext } from '../OrdersContext';
import { NumberFormat } from 'components';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import { applicationContext } from 'helpers/services';
import ReferenceDataKey from 'helpers/enums/ReferenceDataKey';

let Results = () => {
    let service = useContext(ordersContext);
    let appService = useContext(applicationContext);

    return (
        <>
            <TablePagination
                component="div"
                count={service.recordCount}
                onPageChange={service.handleChangePage}
                page={service.search.pageNr}
                rowsPerPage={service.search.pageSize}
                rowsPerPageOptions={[service.search.pageSize]}
                labelDisplayedRows={(props) => {
                    return (
                        <>
                            Total orders:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                            <span>Page {props.page + 1} of {Math.ceil(props.count / service.search.pageSize)}</span>
                        </>
                    )
                }}
            />

            {service.isLoading && <LinearProgress />}
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Order</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Payment status</TableCell>
                        <TableCell>DUE order number</TableCell>
                        <TableCell>Channel</TableCell>
                        <TableCell align="right">Amount</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.orders.length > 0 &&
                        service.orders
                            .map((order, index) =>
                                <TableRow hover key={index}>
                                    <TableCell>
                                        <Typography fontWeight={600}>{order.orderId}</Typography>
                                        <Typography variant='subtitle2'>
                                            <Moment date={order.orderDate} format="LLL" />
                                        </Typography>
                                    </TableCell>
                                    <TableCell>{appService.referenceData[ReferenceDataKey.OrderStatus].getValueByKey(order.orderStatus) ?? ""}</TableCell>
                                    <TableCell>{appService.referenceData[ReferenceDataKey.PaymentStatus].getValueByKey(order.paymentStatus) ?? ""}</TableCell>
                                    <TableCell>{order.erpOrderNumber}</TableCell>
                                    <TableCell>
                                        <Typography>{appService.referenceData[ReferenceDataKey.Channel].getValueByKey(order.channelCode) ?? ""}</Typography>
                                        <Typography variant='subtitle2'>{appService.referenceData[ReferenceDataKey.ChannelType].getValueByKey(order.channelType)}</Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                        <NumberFormat amount={order.amounts?.total} suffix={order.currency} />
                                    </TableCell>
                                    <TableCell align="right">
                                        <Tooltip TransitionComponent={Zoom} title="Details">
                                            <IconButton
                                                color="primary"
                                                size="small"
                                                component={Link}
                                                to={{
                                                    pathname: `/order/${order.id}`,
                                                }}
                                            >
                                                <DetailsIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            )}
                </TableBody>
                {service.orders.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={6}>
                                <Typography variant="subtitle2">No orders found</Typography>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
            <TablePagination
                component="div"
                count={service.recordCount}
                onPageChange={service.handleChangePage}
                page={service.search.pageNr}
                rowsPerPage={service.search.pageSize}
                rowsPerPageOptions={[service.search.pageSize]}
                labelDisplayedRows={(props) => {
                    return (
                        <>
                            Total orders:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                            <span>Page {props.page + 1} of {Math.ceil(props.count / service.search.pageSize)}</span>
                        </>
                    )
                }}
            />
        </>
    );
}

export default Results;